import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { Button, message, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ListingNoAvailable, {
  isInVentoryCountsEmpty,
} from '~pages/dashboard/properties/listing-management/listingNoAvailable';
export default class PropertyDetailWrapper extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      isShowListingEmptyModal: false,
    };
  }

  // 处理 listing available 为0
  isShowPop = hasInVentory => {
    const { status } = this.props?.property;
    const { isShowListingEmptyModal } = this.state;
    if (status === 'PUBLISHED' && hasInVentory) {
      if (!isShowListingEmptyModal) {
        this.setState({ isShowListingEmptyModal: true });
        return true;
      }
    }
    return false;
  };

  handleSave = hasInVentory => {
    const { onClickSave, t, isPublished } = this.props;
    if (this.isShowPop(hasInVentory)) {
      return;
    }
    this.setState({ loading: true });
    onClickSave(res => {
      if (res.status === 'success') {
        if (res.isUpdated) {
          message.success(
            t(`cms.properties.edit.message.${isPublished ? 'publish_success' : 'save_success'}`),
          );
        }
      }
      if (res.status === 'err') {
        if (res.e && res.e.message) {
          if (
            (typeof res.e.message === 'string' &&
              res.e.message.includes('PROPERTY_PENDING_DRAFT_EXISTS')) ||
            (typeof res.e === 'string' && res.e.includes('PROPERTY_PENDING_DRAFT_EXISTS'))
          ) {
            message.error(t('cms.error.property_pending_draft_exists'));
          } else {
            message.error(`${t('cms.message.error')}: ${res.e.message}`);
          }
        } else {
          message.error(`${t('cms.message.error')}: ${res.err?.message}`);
        }
      }
      this.setState({ loading: false });
    });
  };

  handleInsistSave = () => {
    const { rejectedDraftIds } = this.props;
    this.props.expirePropertyDraft(rejectedDraftIds, () => {
      this.handleSave();
    });
  };

  render() {
    const { t, children, isPublished, isHidden, rejectedDraftIds, isValidated, property, canEdit } =
      this.props;
    const { isShowListingEmptyModal } = this.state;
    const hasInVentory = isInVentoryCountsEmpty(property?.unitTypes?.edges);
    return (
      <div
        className={classNames('property-detail-wrapper', {
          'property-detail-wrapper--hidden': isHidden,
          'property-detail-wrapper--reminder': rejectedDraftIds.length > 0,
        })}
      >
        <div className="property-detail-wrapper__content">{children}</div>
        <div className="property-detail-wrapper__footer">
          <div className="property-detail-wrapper__warning">
            <If condition={isPublished}>
              <InfoCircleFilled className="property-detail-wrapper__warning-icon" />
              <span className="property-detail-wrapper__warning-text">
                {t('cms.form.warning.check_before_publish')}
              </span>
            </If>
          </div>

          <Choose>
            <When condition={isValidated && rejectedDraftIds.length > 0}>
              <Popconfirm
                disabled={!canEdit}
                overlayClassName="property-detail-wrapper__popconfirm"
                overlayStyle={{ maxWidth: 210 }}
                placement="topRight"
                title={t('cms.pending_approval.double_confirm.change_detail.title')}
                onConfirm={this.handleInsistSave}
                okText={t('cms.properties.edit.btn.yes')}
                okType="danger"
                cancelText={t('cms.properties.edit.btn.no')}
              >
                <Button disabled={!canEdit} className="property-detail-wrapper__btn" type="primary">
                  {isPublished ? t('cms.properties.edit.btn.publish') : t('cms.form.button.save')}
                </Button>
              </Popconfirm>
            </When>
            <Otherwise>
              <ListingNoAvailable
                confirmHandle={() => {
                  this.handleSave(hasInVentory);
                  this.setState({ isShowListingEmptyModal: false });
                }}
                NewClass={'property-detail-wrapper__publish-right-popUp'}
                isShow={isShowListingEmptyModal}
                onCancel={() => {
                  this.setState({ isShowListingEmptyModal: false });
                }}
              />
              <Button
                onClick={() => {
                  this.handleSave(hasInVentory);
                }}
                className="property-detail-wrapper__btn"
                type="primary"
                loading={this.state.loading}
                disabled={isShowListingEmptyModal || !canEdit}
              >
                {isPublished ? t('cms.properties.edit.btn.publish') : t('cms.form.button.save')}
              </Button>
            </Otherwise>
          </Choose>
        </div>
      </div>
    );
  }
}

PropertyDetailWrapper.propTypes = {
  t: PropTypes.func,
  children: PropTypes.any,
  isPublished: PropTypes.bool,
  onClickSave: PropTypes.func,
  isHidden: PropTypes.bool,
  rejectedDraftIds: PropTypes.array,
  expirePropertyDraft: PropTypes.func,
  isValidated: PropTypes.bool,
  property: PropTypes.object,
  canEdit: PropTypes.bool,
};

PropertyDetailWrapper.defaultProps = {
  t: () => {},
  children: '',
  isPublished: false,
  onClickSave: () => {},
  isHidden: false,
  rejectedDraftIds: [],
  expirePropertyDraft: () => {},
  isValidated: false,
  property: {},
  canEdit: true,
};
